import Pagination from './Pagination.vue';

Pagination.install = (Vue) => {
  Vue.component(Pagination.name, Pagination);
};

export default Pagination;
